export default __webpack_public_path__ + "assets/3364a0ff425ac8549c8485a190fb4f07.jpeg";